import { withStyles, WithStyles } from "@mui/styles";
import classNames from 'classnames';
import MuiLink from 'components/MuiExtras/MuiLink';
import * as React from 'react';
import Lightbox from 'react-images';
import { Styles } from './styles';

interface IState {
    lightboxIsOpen: boolean,
    currentImage: number,
}

interface IProps {
    heading?: string,
    images: Array<any>,
    showThumbnails?: boolean,
    backdropClosesModal?: boolean,
    subheading?: string,
    preventScroll?: boolean,
    spinner?: Function,
    spinnerColor?: string,
    spinnerSize?: number,
    theme?: object,
}

type Props = IProps & WithStyles<typeof Styles>;

class Gallery extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            lightboxIsOpen: false,
            currentImage: 0,
        };

        this.closeLightbox = this.closeLightbox.bind(this);
        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);
        this.gotoImage = this.gotoImage.bind(this);
        this.handleClickImage = this.handleClickImage.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
    }

    static displayName = 'Gallery';

    private openLightbox(index: number, event: any) {
        event.preventDefault();
        this.setState({
            currentImage: index,
            lightboxIsOpen: true,
        });
    }

    private closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }

    private gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }

    private gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    private gotoImage(index: number) {
        this.setState({
            currentImage: index,
        });
    }

    private handleClickImage() {
        if (this.state.currentImage === this.props.images.length - 1) return;

        this.gotoNext();
    }

    private renderGallery() {
        const { images, classes } = this.props;

        if (images == null || images.length == 0) return null;

        const demos = images.filter(i => i.useForDemo);
        const gallery = demos.map((obj, i) => {
            return (
                <a
                    href={obj.src}
                    className={classNames(classes.thumbnail, classes[obj.orientation])}
                    key={i}
                    onClick={(e) => this.openLightbox(i, e)}
                >
                    <img src={obj.thumbnail} alt="Thumbnail" className={classes.source} />
                </a>
            );
        });

        const moreCount = images.length - demos.length;

        return (
            <div>
                <div className={classes.gallery}>
                    {gallery}
                </div>

                {
                    moreCount > 0 &&
                    <MuiLink
                        onClick={(e: any) => this.openLightbox(0, e)}
                    >
                        <span>{images.length} imagens</span>
                    </MuiLink>
                }
            </div>
        );
    }

    render() {
        return (
            <div className="section">
                {this.props.heading && <h2>{this.props.heading}</h2>}
                {this.props.subheading && <p>{this.props.subheading}</p>}
                {this.renderGallery()}
                <Lightbox
                    currentImage={this.state.currentImage}
                    images={this.props.images}
                    isOpen={this.state.lightboxIsOpen}
                    onClickImage={this.handleClickImage}
                    onClickNext={this.gotoNext}
                    onClickPrev={this.gotoPrevious}
                    onClickThumbnail={this.gotoImage}
                    onClose={this.closeLightbox}
                    preventScroll={this.props.preventScroll}
                    showThumbnails={this.props.showThumbnails}
                    imageCountSeparator=" de "
                    closeButtonTitle="Fechar (ESC)"
                    leftArrowTitle="Anterior"
                    rightArrowTitle="Próxima"
                    backdropClosesModal={this.props.backdropClosesModal}
                    spinner={this.props.spinner}
                    spinnerColor={this.props.spinnerColor}
                    spinnerSize={this.props.spinnerSize}
                    theme={this.props.theme}
                />
            </div>
        );
    }
}


export default withStyles(Styles)(Gallery);